/* src/app/order/components/transfer-documents-info/transfer-documents-info.style.scss */
.transfer-documents-panel {
  margin: 0 0 40px 0;
}
.transfer-documents-panel nb-card-body .card-header-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 5px;
}
.transfer-documents-panel nb-card-body #card-header {
  font-size: 22px;
  font-weight: bold;
  color: #007d40;
  margin: 0;
  flex: 1;
  overflow-wrap: break-word;
}
.transfer-documents-panel nb-card-body #card-header.collapsed {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.transfer-documents-panel nb-card-body .toggle-details-section {
  font-family: Arial, sans-serif;
  font-size: 12px;
  font-weight: bold;
  line-height: 1.33;
  text-align: center;
  color: #007d40;
  cursor: pointer;
  text-decoration: none;
  white-space: nowrap;
}
.transfer-documents-panel nb-card-body .toggle-details-section nb-icon {
  position: relative;
  top: 2px;
}
.document-group {
  margin-top: 24px;
}
#transfer-documents {
  margin-top: 20px;
  margin-bottom: 0;
}
/*# sourceMappingURL=transfer-documents-info.style.css.map */
